import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { useConfiguration } from '../../context/configurationContext';
import { propTypes } from '../../util/types';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSideNavigation } from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import css from './LandingPage.module.css';
import MainTabNavVertical from '../../components/MainTabNavVertical/MainTabNavVertical';
import SectionUpcoming from './sections/SectionUpcoming/SectionUpcoming';
import SectionBestMatch from './sections/SectionBestMatch/SectionBestMatch';
import SectionRecentBlogPosts from './sections/SectionRecentBlogPosts/SectionRecentBlogPosts';
import { queryBestMatchListings, queryUpcomingSessions } from './LandingPage.duck';
import { getIsMentor } from '../../util/userUtil';
import SectionStudentInfo from './sections/SectionStudentInfo/SectionStudentInfo';
import SectionMentorInfo from './sections/SectionMentorInfo/SectionMentorInfo';
import SectionNextBookings from './sections/SectionNextBookings/SectionNextBookings';
import FooterContainer from '../FooterContainer/FooterContainer';

export const LandingPageComponent = ({ currentUser = null, ...props }) => {
  const config = useConfiguration();
  const {
    scrollingDisabled,
    currentUserProfileListing,
    queryBestMatchListingsError,
    queryBestMatchListingsInProgress,
    bestMatchListings,
    onQueryBestMatchListings,
    upcomingSessions,
    queryUpcomingSessionsError,
    queryUpcomingSessionsInProgress,
    onQueryUpcomingSessions,
  } = props;

  const title = 'My Dashboard';
  const isMentor = getIsMentor(currentUser);

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        sideNavClassName={css.navigation}
        topbar={
          <>
            <TopbarContainer
              currentPage="LandingPage"
              title="My Dashboard"
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
            />
          </>
        }
        sideNav={<MainTabNavVertical tab="dashboard" currentUser={currentUser} />}
      >
        {isMentor && (
          <>
            <SectionMentorInfo currentUser={currentUser} />
            <SectionNextBookings
              upcomingSessions={upcomingSessions}
              queryUpcomingSessionsError={queryUpcomingSessionsError}
              queryUpcomingSessionsInProgress={queryUpcomingSessionsInProgress}
              onQueryUpcomingSessions={onQueryUpcomingSessions}
              config={config}
            />
            <SectionRecentBlogPosts />
            {/* <SectionNews /> */}
          </>
        )}

        {!isMentor && (
          <>
            <SectionStudentInfo
              currentUser={currentUser}
              currentUserProfileListing={currentUserProfileListing}
            />
            <SectionUpcoming
              upcomingSessions={upcomingSessions}
              queryUpcomingSessionsError={queryUpcomingSessionsError}
              queryUpcomingSessionsInProgress={queryUpcomingSessionsInProgress}
              onQueryUpcomingSessions={onQueryUpcomingSessions}
              config={config}
            />
            <SectionBestMatch
              listings={bestMatchListings}
              queryBestMatchListingsError={queryBestMatchListingsError}
              queryBestMatchListingsInProgress={queryBestMatchListingsInProgress}
              onQueryBestMatchListings={onQueryBestMatchListings}
              config={config}
            />
            <SectionRecentBlogPosts />
            {/* <SectionNews /> */}
          </>
        )}
      </LayoutSideNavigation>

      <FooterContainer />
    </Page>
  );
};



LandingPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => {
  const { currentUser, currentUserProfileListing } = state.user;

  const {
    queryBestMatchListingsError,
    queryBestMatchListingsInProgress,
    bestMatchListings,
    upcomingSessions,
    queryUpcomingSessionsError,
    queryUpcomingSessionsInProgress,
  } = state.LandingPage;

  return {
    currentUser,
    queryBestMatchListingsError,
    queryBestMatchListingsInProgress,
    bestMatchListings,
    currentUserProfileListing,
    upcomingSessions,
    queryUpcomingSessionsError,
    queryUpcomingSessionsInProgress,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onQueryBestMatchListings: config => dispatch(queryBestMatchListings(config)),
  onQueryUpcomingSessions: (only, config) => dispatch(queryUpcomingSessions(only, config)),
});

const LandingPage = compose(connect(mapStateToProps, mapDispatchToProps))(LandingPageComponent);

export default LandingPage;
